module.exports = __webpack_public_path__ + "img/conclusion5.6da740bd.svg";